import useRedditAdvertiserMutator from 'wb-reddit/app/routes/advertisers/hooks/useRedditAdvertiserMutator';
import {
	BlurModal,
	FlagIcon,
	ModalHeader,
} from '@aleph/shared-components';
import { useNavigate, useParams } from 'react-router-dom';
import { useCallback } from 'react';
import RedditAdvertiserMutator from 'wb-reddit/app/routes/advertisers/mutator/advertiserMutator';
import RedditAdvertiserEditMutator from 'wb-reddit/app/routes/advertisers/mutator/advertiserEditMutator';
import { HandleUpdateAdvertiserRow } from 'wb-reddit/app/routes/advertisers/container';
import { SetShowConfirmActionDialog } from 'wb-reddit/app/routes/hooks/useConfirmAction';
import { useTranslation } from 'react-i18next';
import useSaveBeforeExitDialog from 'wb-reddit/app/routes/hooks/useSaveBeforeExitDialog';

interface IProps {
	updateRow: HandleUpdateAdvertiserRow
}

export interface MutatorProps {
	updateRow: HandleUpdateAdvertiserRow
	setShouldShowSaveBeforeExit: SetShowConfirmActionDialog
	beforeClose?: () => void
}

const RedditAdvertiserMutatorContainer = ({ updateRow }: IProps) => {
	const { t } = useTranslation();

	const { mutatingAdvertiser, setMutatingAdvertiser } = useRedditAdvertiserMutator();
	const isUpdate = !!mutatingAdvertiser?.agencyAccountId;
	const navigate = useNavigate();

	const advertiserId = useParams();

	const goBack = useCallback(() => {
		if (mutatingAdvertiser && advertiserId) {
			setMutatingAdvertiser(undefined);

			navigate('/advertisers');
		}

		return setMutatingAdvertiser(undefined);
	}, [mutatingAdvertiser, advertiserId]);

	const {
		beforeClose,
		dialog: saveBeforeExitModal,
		setShouldPromptOnClose: setShouldShowSaveBeforeExit,
	} = useSaveBeforeExitDialog({
		onConfirm:                  goBack,
		defaultShouldPromptOnClose: true,
	});

	return (
		<BlurModal
			header={
				<ModalHeader
					icon={
						<FlagIcon
							width={24}
							height={24}
						/>
					}
					title={isUpdate ? mutatingAdvertiser.agencyAccountName : t('re: advertiser.create', 'Create new advertiser')}
					onClose={beforeClose}
				/>
			}
			onClose={beforeClose}
			blur={isUpdate}
		>
			{isUpdate
				? (
					<RedditAdvertiserEditMutator
						setShouldShowSaveBeforeExit={setShouldShowSaveBeforeExit}
						updateRow={updateRow}
					/>
				)
				: (
					<RedditAdvertiserMutator
						updateRow={updateRow}
						beforeClose={beforeClose}
						setShouldShowSaveBeforeExit={setShouldShowSaveBeforeExit}
					/>
				)
			}
			{saveBeforeExitModal}
		</BlurModal>
	);
};

export default RedditAdvertiserMutatorContainer;
